import React from 'react';
import Navbar from '../components/Navbar';
import Social from '../components/social';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/login.css';

const Login = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // çeviri fonksiyonu

  return (
    <div id='login'>
      <Navbar />
      <div className='wrapper'>
        <a href='/' className='login-logo'>
          <img
            className='logo-img site-logo-img'
            src='https://daiichi.com/new_site/wp-content/uploads/2019/11/daiichi-logo-w.svg'
            width='200'
            alt='DAIICHI Elektronik'
            title='Infotainment Systems'
          />
        </a>

        {/* Supplier Login Button */}
        <div id='log-btn-1' className='log-btn' onClick={() => navigate('/supplier-login')}>
          <span>{t('supplier_login')}</span>
          <svg className='w-6 h-6 text-gray-800 dark:text-white' xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='currentColor' viewBox='0 0 24 24'>
            <path fillRule='evenodd' d='M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z' clipRule='evenodd' />
          </svg>
        </div>

        {/* Document Library Button */}
        <div className='log-btn disabled' aria-hidden='true'>
          <span>{t('document_library')}</span>
          <svg className='w-6 h-6 text-gray-800 dark:text-white' xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
            <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M16.153 19 21 12l-4.847-7H3l4.848 7L3 19h13.153Z' />
          </svg>
        </div>
      </div>

      <Social />

      <style>
        {`
          .log-btn.disabled {
            opacity: 0.6; /* Butonu daha soluk hale getirir */
            cursor: not-allowed; /* Üstüne gelindiğinde fare imlecini yasaklı işaretçi yapar */
          }

          .log-btn.disabled:hover {
            cursor: not-allowed; /* Hover durumunda da yasaklı işaretçi olacak */
          }
        `}
      </style>
    </div>
  );
};

export default Login;
